const InProgressBody = () => {
  return (
    <p>
      The security products listed here are in various stages of NIAP
      evaluation.
      <span className="fw-bold">
        {" "}
        There is no guarantee that any of these products will complete
        evaluation successfully.
      </span>
    </p>
  );
};
export default InProgressBody;
